const chainId = 8453 as const;
const abi = [
  {
    type: "function",
    name: "themeColors",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint96",
        internalType: "uint96",
      },
    ],
    stateMutability: "pure",
  },
] as const;

export default { abi, chainId };
